'use client'

import { usePushToDataLayer } from '@/hooks/analytics/use-push-to-data-layer'
import { EPageType, ETrackingEvent } from '@/lib/gtm/type'

type BaseProps = {
  page_type?: EPageType
  event?: ETrackingEvent
}

type TrackingDataLayerProps<T extends BaseProps> = {
  data: T
}

export const TrackingDataLayer = <T extends BaseProps>({
  data,
}: TrackingDataLayerProps<T>) => {
  usePushToDataLayer<T>(data)

  return null
}
